import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        FetchLatestStudentCollegeCardByStudentReference({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/college-cards/fetch/studentreference`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data.payload);
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchLatestStudentCollegeCardByStudentReference: ${error.message}`));
            });
        },
        FetchStudentCollegeCardOptInByStudentID({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/college-cards/opt-in/fetch/studentid`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data.payload);
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchStudentCollegeCardOptInByStudentID: ${error.message}`));
            });
        },
        UpsertStudentCollegeCardOptIn({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/college-cards/opt-in/upsert`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => { reject(error.message); });
            });
        },
    },
}
